import { createDrawerStore } from '../drawer/createDrawerStore';

export const useDriverDrawerStore = createDrawerStore();
